// @core/api/endpoints/affiliate/request_payout.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PayoutResponse,
  RequestPayoutRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Request payout
 * Affiliate requests a payout for their earned commissions.
 */
export async function RequestPayout(
  data: RequestPayoutRequest,
  options?: RequestOptions
): Promise<PayoutResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/payouts`;
  const requestOptions = options;
  return client.post<PayoutResponse>(requestPath, data, requestOptions);
}
